import { atom, useRecoilValue, useSetRecoilState } from 'recoil';

export const DefinedError = {
  AuthConversationRestoreError: 'GBB-MSG-0001',
  AuthConversationInitiateError: 'GBB-MSG-0002',
  UnAuthConversationInitiateError: 'GBB-MSG-0003',
  InConversationError: 'GBB-MSG-0004',
};

const definedErrorState = atom({
  key: 'genesysDefinedError',
  default: '',
});

export const useGenesysError = () => useRecoilValue(definedErrorState);

export const useSetGenesysError = () => useSetRecoilState(definedErrorState);
